import { useOutletContext } from 'react-router-dom';
import type { ChannelOption } from '../components/ScenarioHeader/constants';

export interface ScenarioContextType {
  selectedChannel: ChannelOption | null;
  setSelectedChannel: (channel: ChannelOption) => void;
  isSingleChannel: boolean;
  setIsSingleChannel: (value: boolean) => void;
}

// Typed wrapper around useOutletContext for the Scenario wizard.
// All child routes of ScenarioWrapper can call this to read/write
// the selected channel state that persists across route navigation.
export function useScenarioContext(): ScenarioContextType {
  return useOutletContext<ScenarioContextType>();
}
